<template>
    <section>

        <div class="container">
            <div class="tools">
                <button type="button" id="tooltip-reset" class="btn btn-outline-danger undo-button" v-if="isModified" v-on:click="reset">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                    </svg>
                    <b-tooltip target="tooltip-reset" variant="info">Revenir à l'énoncé original</b-tooltip>
                </button>
                <button type="button" id="tooltip-gear" class="btn btn-outline-danger" v-if="isEditor" @click="editProblemInThisWindow(publicID)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
                    </svg>
                <b-tooltip target="tooltip-gear" variant="info">Modifier dans la base de problèmes</b-tooltip>
                </button>
                <button v-if="isAIAvailable" type="button" id="tooltip-ai" class="btn btn-outline-warning ai-button" @click="generateWithoutNumbers" :disabled="showEdit || isGenerating">
                    <i v-if="!isGenerating" class="bi bi-stars" aria-hidden="true"></i>
                    <span v-if="isGenerating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
                <button type="button" id="tooltip-edit" class="btn btn-outline-success" v-on:click="showEdit=!showEdit" v-if="cookieAccepted">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                    <b-tooltip ref="tooltipEdit" target="tooltip-edit" variant="info">Modifer l'énoncé sur cet ordinateur</b-tooltip>
                </button>
                <button type="button" id="tooltip-copy" class="btn btn-outline-success" @click="copy" :disabled="showEdit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-clipboard-check" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                    </svg>
                </button>
                <button type="button" id="tooltip-rod" class="btn btn-outline-success" @click="showTools=!showTools">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-bar-chart-fill" viewBox="0 0 16 16">
                        <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>
                    </svg>
                </button>

                <b-tooltip ref="tooltipAI" target="tooltip-ai" variant="info" placement="bottom">Masquer les nombres</b-tooltip>
                <b-tooltip ref="tooltipCopy" target="tooltip-copy" variant="info">Copier le texte de l'énoncé dans le presse-papier</b-tooltip>
                <b-tooltip ref="tooltipTools" target="tooltip-rod" variant="info">Outil réglettes</b-tooltip>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="text-center">

                    <div class="card-text" v-if="!showEdit">
                        <pre>{{ pbText }}</pre>
                    </div>

                    <div class="card-text" v-show="showEdit">
                        <form name="editForm">
                            <textarea ref="edit" class="edit" type="text" v-model="pbText" onfocus="let value = this.value; this.value = null; this.value = value"></textarea>
                        </form>
                    </div>

                    <div v-show="withPIC">
                        <img :src="picURL"/>
                    </div>

                </div>
            </div>
            <div class="col" v-show="showTools" >
                <iframe width="150%" src="https://arnaud-lierville.github.io/responsive-rod.html" frameborder="0"></iframe>
            </div>
        </div>
        
        <textarea ref="copyText" class="copyText" v-model="pbText" rows="1" cols="1"></textarea>
        <b-modal id="done" hide-footer hide-header>
            <div class="text-center">
                <h3 class="text-success">Copié !</h3>
            </div>
        </b-modal>
        <b-modal id="ai-success" hide-footer hide-header>
            <div class="text-center">
                <h3 class="text-success">Les quantités ont été masquées !</h3>
                <p class="text-danger mt-3">
                    <strong>Attention :</strong> vérifiez que l'énoncé reste cohérent et exploitable
                </p>
            </div>
        </b-modal>
        <b-modal id="ai-error" hide-footer hide-header>
            <div class="text-center">
                <h3 class="text-danger">Impossible d'utiliser l'IA</h3>
                <p class="text-muted">{{ aiErrorMessage }}</p>
            </div>
        </b-modal>

        <footer>
            <cookie-law theme="base" 
            buttonText="Je suis d'accord !" 
            v-on:accept="thankYouMethod()" 
            :buttonDecline='true'
            buttonDeclineText="Je refuse"
            buttonDeclineClass="btn btn-danger"
            buttonClass="btn btn-success"
            storageName="pel:accepted">
                <div slot="message">
                    Les énoncés modifiés sont enregistrés dans votre navigateur.
                </div>
            </cookie-law>
        </footer>
        
    </section>
  
</template>

<script>
// @ is an alias to /src
import { onAuthStateChanged } from '../auth/firebase'
import { editProblemInThisWindow } from '../utils'
import CookieLaw from 'vue-cookie-law'

export default {
    title () { return `Problème #${this.$route.params.publicID}` },
    name: 'Problem',
    data() {
        return {
            showEdit: false,
            showTools: false,
            pbText: null,
            originalText: null,
            localData: {},
            isModified: false,
            problemQuery: Array,
            problem: null,
      problemId: null,
            withPIC: false,
            picURL: null,
            user: null,
            isGenerating: false,
            cookieAccepted: null,
            aiErrorMessage: 'Erreur lors de la génération',
            aiEnabled: true, // Default to true, will be updated from system config
            aiSessionId: null, // Session ID for temporary AI access
            hasValidAISession: false,
            sessionCheckTimeout: null // Timeout pour vérifier la session à l'expiration
        }
    },
    components: {
        CookieLaw
    },
    async created() {
        this.cookieAccepted = localStorage.getItem('pel:accepted')
        this.user = await onAuthStateChanged(this.db)
        await this.loadSystemConfig()
        this.checkAISession()
        
        // Programmer la vérification de session (sera programmée intelligemment par checkAISession)
        this.scheduleSessionCheck()
        
        // Écouter les changements de localStorage depuis d'autres onglets
        window.addEventListener('storage', this.handleStorageChange)
    },
    beforeDestroy() {
        // Nettoyer les timers quand le composant est détruit
        if (this.sessionCheckTimeout) {
            clearTimeout(this.sessionCheckTimeout)
        }
        // Retirer l'écouteur d'événements
        window.removeEventListener('storage', this.handleStorageChange)
    },
    mounted() {
        this.publicID = this.$route.params.publicID
        // Vérifier à nouveau la session après le montage pour s'assurer que l'état est correct
        this.$nextTick(() => {
            this.checkAISession()
        })
    },
    computed: {
        isEditor() {
        let isEditor = false
        if(this.user) { isEditor = this.user.isEditor }
        return isEditor 
        },
        isAIAvailable() {
            // Le bouton doit être affiché si l'IA est disponible globalement OU si une session temporaire est valide
            return this.aiEnabled || this.hasValidAISession
        }
    },
    firestore() {
        const parsedId = parseInt(this.$route.params.publicID);
        return {
            problemQuery: this.db.collection('problems').where('publicID', '==', parsedId)
        }
    },
    watch: {
        pbText(newPbText) {
            if(newPbText != this.originalText && this.cookieAccepted) {
                this.isModified = true
                this.localData[this.publicID] = {
                    pbText: newPbText,
                    isModified: true
                }
                const parsed = JSON.stringify(this.localData);
                localStorage.setItem('pel', parsed);
                }
        },
        showEdit(value) {
            if(value) {
                this.$nextTick(() => this.$refs.edit.focus())
            }
            this.$refs.tooltipEdit.$emit('close')
        },
        showTools() {
            this.$refs.tooltipTools.$emit('close')
            this.showEdit = false
        },
        async problemQuery() {
            if(this.problemQuery.length == 1) {

                this.problem = this.problemQuery[0]
                this.problemId = this.problemQuery[0]?.id || null
                this.pbText = this.problem.text
                this.originalText = this.problem.text

                if(this.problem.picNameFile) {
                    this.withPIC = true
                    this.picURL = await this.storageRef.child(this.problem.picNameFile).getDownloadURL()
                }

                if (localStorage.getItem('pel') && this.cookieAccepted) {
                    try {
                        this.localData = JSON.parse(localStorage.getItem('pel'));
                        if(this.localData[this.$route.params.publicID].isModified) {
                            this.pbText = this.localData[this.$route.params.publicID].pbText
                            this.isModified = true
                        }
                    } catch(e) {
                        localStorage.removeItem('pel');
                    }
                }
            }
        }
    },
    methods: {
        reset: function() {
            this.localData[this.publicID] = {
                pbText: this.originalText,
                isModified: false
            }
            const parsed = JSON.stringify(this.localData)
            localStorage.setItem('pel', parsed)
            this.isModified = false
            this.pbText = this.originalText
            this.showEdit = false
        },
        editProblemInThisWindow: editProblemInThisWindow,
        copy() {
            this.$refs.copyText.select()
            document.execCommand('copy')
            this.$refs.tooltipCopy.$emit('close')
            this.$bvModal.show('done')
            setTimeout(() => { this.$bvModal.hide('done') }, 1000);
        },
        thankYouMethod() {
            this.cookieAccepted = localStorage.getItem('pel:accepted')
        },
        async loadSystemConfig() {
            try {
                const doc = await this.db.collection('system').doc('config').get()
                if (doc.exists) {
                    const data = doc.data() || {}
                    // Si aiEnabled est explicitement false, alors false, sinon true (par défaut ou si undefined)
                    this.aiEnabled = data.aiEnabled !== false
                } else {
                    // Si le document n'existe pas, par défaut activé
                    this.aiEnabled = true
                }
            } catch (error) {
                // En cas d'erreur (permissions, etc.), on désactive par sécurité
                // L'utilisateur pourra toujours utiliser une session temporaire si nécessaire
                this.aiEnabled = false
            }
        },
        checkAISession() {
            const sessionId = localStorage.getItem('aiSessionId')
            const expiresAt = localStorage.getItem('aiSessionExpires')
            
            if (sessionId && expiresAt) {
                const now = Date.now()
                const expiryTime = parseInt(expiresAt, 10)
                
                // Vérifier que expiryTime est un nombre valide
                if (isNaN(expiryTime)) {
                    localStorage.removeItem('aiSessionId')
                    localStorage.removeItem('aiSessionExpires')
                    this.aiSessionId = null
                    this.hasValidAISession = false
                    this.scheduleSessionCheck() // Réinitialiser la vérification
                    return
                }
                
                if (now < expiryTime) {
                    // Session is still valid
                    this.aiSessionId = sessionId
                    this.hasValidAISession = true
                    // Programmer la vérification à l'expiration exacte
                    this.scheduleSessionCheck(expiryTime - now)
                } else {
                    // Session expired, clean up
                    localStorage.removeItem('aiSessionId')
                    localStorage.removeItem('aiSessionExpires')
                    this.aiSessionId = null
                    this.hasValidAISession = false
                    // Plus de session, arrêter les vérifications
                    this.scheduleSessionCheck()
                }
            } else {
                this.aiSessionId = null
                this.hasValidAISession = false
                if (!sessionId && !expiresAt) {
                    // Pas de session du tout, c'est normal
                } else {
                    // Session incomplète, nettoyer
                    localStorage.removeItem('aiSessionId')
                    localStorage.removeItem('aiSessionExpires')
                }
                // Plus de session, arrêter les vérifications
                this.scheduleSessionCheck()
            }
        },
        scheduleSessionCheck(delayMs = null) {
            // Annuler la vérification précédente si elle existe
            if (this.sessionCheckTimeout) {
                clearTimeout(this.sessionCheckTimeout)
                this.sessionCheckTimeout = null
            }
            
            // Si aucun délai n'est fourni, vérifier s'il y a une session à programmer
            if (delayMs === null) {
                const sessionId = localStorage.getItem('aiSessionId')
                const expiresAt = localStorage.getItem('aiSessionExpires')
                
                if (sessionId && expiresAt) {
                    const now = Date.now()
                    const expiryTime = parseInt(expiresAt, 10)
                    
                    if (!isNaN(expiryTime) && now < expiryTime) {
                        // Programmer la vérification à l'expiration
                        delayMs = expiryTime - now
                    } else {
                        // Session expirée ou invalide, pas besoin de programmer
                        return
                    }
                } else {
                    // Pas de session, pas besoin de programmer
                    return
                }
            }
            
            // Programmer la vérification uniquement si on a un délai valide
            if (delayMs !== null && delayMs > 0) {
                // Ajouter 1 seconde de marge pour s'assurer que l'expiration est détectée
                this.sessionCheckTimeout = setTimeout(() => {
                    this.checkAISession()
                }, delayMs + 1000)
            }
        },
        handleStorageChange(event) {
            // Détecter les changements de session AI dans localStorage
            if (event.key === 'aiSessionId' || event.key === 'aiSessionExpires') {
                this.checkAISession()
                // Réinitialiser la programmation de vérification
                this.scheduleSessionCheck()
            }
        },
        async generateWithoutNumbers() {
            if (!this.pbText || this.isGenerating) {
                return
            }

            this.isGenerating = true
            this.$refs.tooltipAI.$emit('close')

            try {
                let resolvedProblemId = this.problemId
                if (!resolvedProblemId) {
                    const snapshot = await this.db.collection('problems')
                        .where('publicID', '==', parseInt(this.publicID, 10))
                        .limit(1)
                        .get()
                    if (!snapshot.empty) {
                        resolvedProblemId = snapshot.docs[0].id
                        this.problemId = resolvedProblemId
                    }
                }

                if (!resolvedProblemId) {
                    throw new Error('Impossible de déterminer l’identifiant du problème.')
                }

                // Get the Firebase project ID from config
                const projectId = 'live-problem' // From firebase config
                const functionUrl = `https://us-central1-${projectId}.cloudfunctions.net/generateWithoutNumbers`

                // Always use original text for AI generation
                if (!this.originalText) {
                    throw new Error('Texte original non disponible')
                }

                // Check session again before sending request
                this.checkAISession()
                
                const requestBody = {
                    text: this.originalText,
                    problemId: resolvedProblemId
                }
                
                // Add sessionId if available
                if (this.aiSessionId) {
                    requestBody.sessionId = this.aiSessionId
                }

                const response = await fetch(functionUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                })

                if (!response.ok) {
                    let errorMessage = 'Erreur lors de la génération'
                    try {
                        const errorData = await response.json()
                        if (errorData?.error) {
                            errorMessage = errorData.error
                        }
                    } catch (e) {
                        // ignore json parsing errors
                    }
                    
                    // Handle specific error codes
                    if (response.status === 429) {
                        errorMessage = 'Trop de requêtes. Veuillez patienter quelques instants avant de réessayer.'
                    } else if (response.status === 400 && errorMessage.includes('does not match')) {
                        errorMessage = 'Le texte ne correspond pas au problème. Veuillez recharger la page.'
                    } else if (response.status === 404) {
                        errorMessage = 'Problème introuvable.'
                    } else if (response.status === 403) {
                        if (errorMessage === 'AI generation is disabled') {
                            errorMessage = 'La génération IA est désactivée pour le moment.'
                            // Si on a une session mais que le backend refuse, la session est probablement expirée
                            if (this.aiSessionId) {
                                localStorage.removeItem('aiSessionId')
                                localStorage.removeItem('aiSessionExpires')
                                this.aiSessionId = null
                                this.hasValidAISession = false
                            }
                        } else if (errorMessage.includes('session') || errorMessage.includes('Session')) {
                            // Session invalide ou expirée
                            localStorage.removeItem('aiSessionId')
                            localStorage.removeItem('aiSessionExpires')
                            this.aiSessionId = null
                            this.hasValidAISession = false
                        }
                    }
                    
                    throw new Error(errorMessage)
                }

                const data = await response.json()
                
                if (data.text) {
                    // Log info selon la source de l'énoncé
                    if (data.cached) {
                        // eslint-disable-next-line no-console
                        console.info('[IA] Énoncé récupéré depuis la base de données (cache)')
                    } else {
                        // eslint-disable-next-line no-console
                        console.info('[IA] Énoncé généré par l\'IA et sauvegardé')
                    }
                    
                    this.pbText = data.text
                    this.isModified = true
                    this.aiErrorMessage = 'Erreur lors de la génération'
                    this.$bvModal.show('ai-success')
                    setTimeout(() => { this.$bvModal.hide('ai-success') }, 5000)
                } else {
                    throw new Error('Aucun texte généré')
                }
            } catch (error) {
                let message = error?.message || 'Erreur lors de la génération'
                if (message === 'AI generation is disabled') {
                    message = 'La génération IA est désactivée pour le moment.'
                }
                this.aiErrorMessage = message
                this.$bvModal.show('ai-error')
                setTimeout(() => { this.$bvModal.hide('ai-error') }, 3000)
            } finally {
                this.isGenerating = false
            }
        }
    }
}
</script>

<style scoped>
    pre {
        font-family:    -apple-system, BlinkMacSystemFont, "Segoe UI", Android Roboto, 
                        "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", 
                        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", 
                        "Segoe UI Symbol", "Noto Color Emoji";
        font-size: xx-large;
        white-space: pre-wrap;  
    }
    img {
        margin: 32px 0 0 0;
        max-height: 20vw;
    }
    .tools {
        position: fixed;
        right: 0!important;
        top: 0!important;
        margin: 8px 8px 0 0;
    }
    .tools button {
        margin: 0px 2px 0px 2px;
        box-shadow: 0 1px 3px black;
        width: 48px;
        height: 48px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
    }
    .tools .ai-button {
        border-color: #fd7e14;
        color: #fd7e14;
    }
    .tools .ai-button:hover,
    .tools .ai-button:focus {
        background-color: #fd7e14;
        color: #fff;
    }
    .edit {
        resize: none;
        border: solid 2px;
        border-color: #198754;
        height: calc(50vh);
        width: 100%;
        text-align: center;
        outline: none;
        white-space: pre-wrap;
        font-size: xx-large;
        overflow:hidden;
        padding: 16px 16px 16px 16px;
        margin: 16px 16px 16px 16px;
    }
    .container {
        width: 100%;
        margin: 64px auto;
    }
    .copyText {
        resize: none;
        outline: none;
        white-space: pre-wrap;
        font-size: 0px;
        overflow:hidden;
        border: solid 2px;
        border-color: white;
        color: white
    }
    iframe {
        height: calc(100vh);
    }
</style>